import P from "./index30.js";
import n from "./index46.js";
const a = {
  MASKED: "value",
  UNMASKED: "unmaskedValue",
  TYPED: "typedValue"
};
function u(t, e, r) {
  e === void 0 && (e = a.MASKED), r === void 0 && (r = a.MASKED);
  const i = P(t);
  return (E) => i.runIsolated((p) => (p[e] = E, p[r]));
}
function o(t, e, r, i) {
  return u(e, r, i)(t);
}
n.PIPE_TYPE = a;
n.createPipe = u;
n.pipe = o;
export {
  a as PIPE_TYPE,
  u as createPipe,
  o as pipe
};
